const MuiFormHelperText = {
    contained: {
        marginLeft: 0,
    },
};
export default MuiFormHelperText;
